<template>
  <b-nav-item @click="skin = isDark ? 'light' : 'dark'">
    <feather-icon
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
    />
  </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed, watch } from '@vue/composition-api'
import { BNavItem } from 'bootstrap-vue'
import  skinStore  from './useBookmark_lang_skin'

export default {
  components: {
    BNavItem,
  },
  props: {
    spinner: {
      type: Boolean,
      default: () => false
    }
  },

  setup(props, {emit}) {

    const { skin } = useAppConfig()

    const { skinToggle } = skinStore()

    const isDark = computed(() => skin.value === 'dark')

    watch(skin, val => {
      emit('update:spinner', true)
      skinToggle(isDark.value, () => emit('update:spinner', false))
    })

    return { skin, isDark }

  },
}
</script>
